import classNames from 'classnames';
import { map, get, head } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'components/Button';
import SizeButton from 'components/SizeButton';
import { SubBold } from 'components/Sub';
import { TYPES } from 'constants/merchandising';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';
import Size from 'utils/Size';

const SIZES_PER_ROW = 6;

const DesktopSizeSelector = ({ sortedSizes, onSizeSelection, type }) => (
  <div className="DesktopSizeSelector">
    <div className="DesktopSizeSelector__content">
      {sortedSizes.length === 1 ? (
        <Button
          onClick={() => onSizeSelection(get(head(sortedSizes), 'id'), '#size-selector')}
          isFullWidth
          className="DesktopSizeSelector__add-to-cart"
        >
          {I18n.localize('collectionPage.productCards.addToCart')}
        </Button>
      ) : (
        <div>
          <SubBold className="DesktopSizeSelector__quick-add-title">
            {I18n.localize('collectionPage.productCards.quickAdd')}
          </SubBold>
          <ul className="DesktopSizeSelector__grid">
            {map(sortedSizes, ({ id, value, available }) => (
              <li
                className={classNames('DesktopSizeSelector__grid-item', {
                  'DesktopSizeSelector__grid-item--2-column': type === TYPES.SOCKS,
                  'DesktopSizeSelector__grid-item--3-column':
                    type !== TYPES.SOCKS && !Size.isSizeButtonSquare(value),
                })}
                key={id}
              >
                <SizeButton
                  label={value}
                  available={available}
                  disabled={!available}
                  onClick={() => onSizeSelection(id, '#size-selector')}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
    <style jsx>
      {`
        .DesktopSizeSelector {
          position: absolute;
          left: -${Theme.get('spacing') * 4}px;
          right: -${Theme.get('spacing') * 4}px;
          top: calc(100% + ${Theme.get('spacing') * 2}px);
          background-color: ${Theme.get('colors-white')};
          box-shadow:
            0 -10px 0 0 white,
            0 10px 20px 0 rgba(0, 0, 0, 0.23);
        }

        .DesktopSizeSelector__content {
          padding: 0 ${Theme.get('spacing') * 4}px ${Theme.get('spacing') * 4}px;
        }

        .DesktopSizeSelector__grid {
          padding: 0;
          margin: 0 ${Theme.get('spacing') / -2}px 0;
          display: flex;
          flex-wrap: wrap;
        }

        .DesktopSizeSelector__grid-item {
          display: inline-block;
          width: ${100 / SIZES_PER_ROW}%;
          max-width: ${Theme.get('spacing') * 8.5}px;
          padding: 0 ${Theme.get('spacing') / 2}px ${Theme.get('spacing')}px;
          margin: 0;
        }

        .DesktopSizeSelector__grid-item--2-column {
          width: 100%;
          max-width: none;
          flex: 0 0 50%;
        }

        .DesktopSizeSelector__grid-item--3-column {
          width: 100%;
          max-width: none;
          flex: 0 0 33.3333%;
        }
      `}
    </style>
    <style jsx global>
      {`
        .DesktopSizeSelector__quick-add-title.Sub--bold {
          display: block;
          padding-bottom: ${Theme.get('spacing') * 2}px;
        }
      `}
    </style>
  </div>
);

DesktopSizeSelector.propTypes = {
  sortedSizes: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, value: PropTypes.string, available: PropTypes.bool })
  ).isRequired,
  sizes: PropTypes.shape({}),
  onSizeSelection: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default DesktopSizeSelector;
